module.exports = __webpack_public_path__ + "static/media/provider_scientific.729f9af6.png";